import { defineFurniture } from './types.js';

/**
 * Game tables. Each carries `interaction: { type: 'game', game }`, which
 * opens the table's game window when clicked. Owned by the games feature.
 */
export const GAME_FURNITURE = defineFurniture('games', {
  tictactoe_table: {
    label: 'Tic-tac-toe Table',
    description: 'Three in a row wins. A classic for two.',
    price: 300,
    solid: true,
    height: 0.9,
    interaction: { type: 'game', game: 'tictactoe' },
  },
  connect4_table: {
    label: 'Connect Four Table',
    description: 'Drop discs and line up four before your kaki does.',
    price: 500,
    solid: true,
    height: 1.2,
    interaction: { type: 'game', game: 'connect4' },
  },
  checkers_table: {
    label: 'Checkers Table',
    description: 'Dam, like at the void deck. Captures are compulsory!',
    price: 800,
    solid: true,
    height: 0.9,
    interaction: { type: 'game', game: 'checkers' },
  },
  xiangqi_table: {
    label: 'Chinese Chess Table',
    description: 'Xiangqi, the uncles favourite. Protect your general.',
    price: 1200,
    solid: true,
    height: 0.9,
    interaction: { type: 'game', game: 'xiangqi' },
  },
  snakes_mat: {
    label: 'Snakes & Ladders Mat',
    description: 'A giant floor board for 2 to 8 players. Roll and pray.',
    price: 600,
    solid: false,
    height: 0,
    interaction: { type: 'game', game: 'snakes' },
  },
  poker_table: {
    label: 'Poker Table',
    description: "Texas Hold'em for 2 to 6, played for fun chips only. Bots can fill empty seats.",
    // No longer sold (price 0 = not for sale); existing tables keep working.
    price: 0,
    solid: true,
    height: 0.9,
    interaction: { type: 'game', game: 'poker' },
  },
  mahjong_table: {
    label: 'Mahjong Table',
    description: 'Singapore mahjong for four, with flowers and animals. Fun chips only; bots fill empty seats.',
    // No longer sold (price 0 = not for sale); existing tables keep working.
    price: 0,
    solid: true,
    height: 0.9,
    interaction: { type: 'game', game: 'mahjong' },
  },
  court_table: {
    label: 'Court Round Table',
    description: 'Shadow Court for 5 to 10: hidden roles, secret missions and one traitor too many. Bots can fill empty seats.',
    price: 2000,
    solid: true,
    height: 0.9,
    interaction: { type: 'game', game: 'court' },
  },
  bazaar_table: {
    label: 'Bazaar Table',
    description: 'Collect gems, buy jewels and win over nobles. Spice Bazaar for 2 to 4, first to 15 points.',
    price: 1200,
    solid: true,
    height: 0.9,
    interaction: { type: 'game', game: 'bazaar' },
  },
  floatingbridge_table: {
    label: 'Floating Bridge Table',
    description: 'Bid for trump, call a secret partner, and win the trick war. A kopitiam classic for four. Bots can fill empty seats.',
    price: 1000,
    solid: true,
    height: 0.9,
    interaction: { type: 'game', game: 'floatingbridge' },
  },
});
